export default "__VITE_ASSET__svfde82i__"